import clsx from 'clsx';
import React from 'react';

const PageDetailHeader = ({ children, className }) => {
  return (
    <div
      className={clsx(
        `pt-6 px-4 overflow-y-auto max-h-screen space-y-1`,
        className,
      )}
    >
      {children}
    </div>
  );
};

const Title = ({ children }) => {
  return (
    <div className="text-2xl font-bold text-gray-900 py-2">{children}</div>
  );
};

PageDetailHeader.Title = Title;

export default PageDetailHeader;
